import { Injectable } from '@angular/core';
import { SnapshotService } from './snapshot.service';
import { BehaviorSubject, Observable, map } from 'rxjs';
import { ConfigurationService } from 'src/app/common/services/configuration.service';
import { results } from 'src/app/common/models/common.model';

@Injectable({
  providedIn: 'root',
})
export class CommonChartmoduleService {
  constructor(private _configService: SnapshotService,private configureservice:ConfigurationService) { 
    
  this.allSnapshotTypes = this._configService.clientSnapshotAllStudyNames;
   
    }
  private widgetsSubject = new BehaviorSubject<any[]>([]);
  private studyNames = new BehaviorSubject<any[]>([]);
  studyNames$ = this.studyNames.asObservable();
  allSnapshotTypes = this._configService.clientSnapshotAllStudyNames;
  color1: string[]=[];
  brandcolors: string[] = [];

  updateStudyNames(newStudyNames: any[]) {
    this.studyNames.next(newStudyNames);
  }
  widgets$ = this.widgetsSubject.asObservable();

  updateWidgets(widgets: any[]) {
    this.widgetsSubject.next(widgets);
  }
  defaultSelectedSnapshotType: string = this._configService.snapshotTypeSelectedName;
  async wait() {
    await new Promise(resolve => setTimeout(resolve, 30000)); // Wait for 1 second
    // This code will not execute for 1 second
  }

  customizationObject: any = {
    "Study": {
      customization: 'Study : ', func: 'applycustomization', inputType: 'dropdown', className: '', id: '',
      options: this.allSnapshotTypes
      //   options:this.studyNames$.map(study => ({
      //     value: study.name.toLowerCase().replace(/ /g, ''),
      //     label: study.name
    },
    "WidgetName": {
      customization: 'Widget Name : ', func: 'applycustomization', inputType: 'text', className: '', id: ''
    },
    "NumberOfMetricVisible": (number: any) => {
      return {
        customization: 'Metric : ', func: 'applycustomization', inputType: 'checkboxlist', className: '', id: '', select: number, showDropdown: false, checkedList: [], options: [
          { value: 'metric1', label: 'Metric 1' }, { value: 'metric2', label: 'Metric 2' }, { value: 'metric3', label: 'Metric 3' }, { value: 'metric4', label: 'Metric 4' },
        ]
      }
    },
    "XAxis": {
      customization: 'XAxis Metric : ', func: 'applycustomization', inputType: 'checkboxlist', className: 'XAxis Metric : ', id: 'XAxis Metric', select: 1, showDropdown: false, checkedList: [], options: [
        { value: 'metric1', label: 'Metric 1' }, { value: 'metric2', label: 'Metric 2' }, { value: 'metric3', label: 'Metric 3' }, { value: 'metric4', label: 'Metric 4' },
      ]
    },
    "YAxis": {
      customization: 'YAxis Metric : ', func: 'applycustomization', inputType: 'checkboxlist', className: 'YAxis Metric', id: 'YAxis Metric', select: 1, showDropdown: false, checkedList: [], options: [
        { value: 'metric1', label: 'Metric 1' }, { value: 'metric2', label: 'Metric 2' }, { value: 'metric3', label: 'Metric 3' }, { value: 'metric4', label: 'Metric 4' },
      ]
    },
    "ZAxis": {
      customization: 'ZAxis Metric : ', func: 'applycustomization', inputType: 'checkboxlist', className: 'ZAxis Metric', id: 'ZAxis Metric', select: 1, showDropdown: false, checkedList: [], options: [
        { value: 'metric1', label: 'Metric 1' }, { value: 'metric2', label: 'Metric 2' }, { value: 'metric3', label: 'Metric 3' }, { value: 'metric4', label: 'Metric 4' },
      ]
    },
    "XAxisLabelOrientation": {
      customization: 'X Axis Label Orientation : ', func: 'applycustomization', inputType: 'images', className: '', id: 'X Axis Label Orientation', options: [
        // { value: 'automatic', label: 'Automatic' },
        // { value: 'horizontal', label: 'Horizontal', selected: true, imgClassName: 'axisHorizontal', selectedImgClassName: 'axisHorizontalSelected' },
        // { value: 'vertical', label: 'Vertical', selected: false, imgClassName: 'axisVertical', selectedImgClassName: 'axisVerticalSelected' },
        // { value: 'angled', label: 'Angled', selected: false, imgClassName: 'axisAngled', selectedImgClassName: 'axisAngledSelected' },
        { value: 'horizontal', label: 'Horizontal', selected: true, imgClassName: 'axisHorizontal', selectedImgClassName: 'axisHorizontalSelected' },
        { value: 'vertical', label: 'Vertical', selected: false, imgClassName: 'axisVertical', selectedImgClassName: 'axisVerticalSelected' },
        { value: 'angled', label: 'Angled', selected: false, imgClassName: 'axisAngled', selectedImgClassName: 'axisAngledSelected' },
      ]
    },
    "YAxisLabelOrientation": {
      customization: 'Y Axis Label Orientation : ', func: 'applycustomization', inputType: 'images', className: '', id: 'Y Axis Label Orientation', options: [
        { value: 'horizontal', label: 'Horizontal', selected: true, imgClassName: 'axisHorizontal', selectedImgClassName: 'axisHorizontalSelected' },
        { value: 'vertical', label: 'Vertical', selected: false, imgClassName: 'axisVertical', selectedImgClassName: 'axisVerticalSelected' },
        { value: 'angled', label: 'Angled', selected: false, imgClassName: 'axisAngled', selectedImgClassName: 'axisAngledSelected' },
      ]
    },
    "ZAxisLabelOrientation": {
      customization: 'Z Axis Label Orientation : ', func: 'applycustomization', inputType: 'dropdown', className: '', id: 'Z Axis Label Orientation', options: [
        { value: 'automatic', label: 'Automatic' },
        { value: 'horizontal', label: 'Horizontal', selected: true, imgClassName: 'axisHorizontal', selectedImgClassName: 'axisHorizontalSelected' },
        { value: 'vertical', label: 'Vertical', selected: false, imgClassName: 'axisVertical', selectedImgClassName: 'axisVerticalSelected' },
        { value: 'angled', label: 'Angled', selected: false, imgClassName: 'axisAngled', selectedImgClassName: 'axisAngledSelected' },
      ]
    },
    "HundredPercentStackedChart": {
      customization: '100% Stacked Chart : ',
      func: 'applycustomization',
      inputType: 'toggle',
      className: '100PercentStackedChart',
      id: '100PercentStackedChart',
      options: [
        { value: true, label: 'On', selected: false },
        { value: false, label: 'Off', selected: true },
      ],
    },
    "StackPosition": {
      customization: 'Stack Position : ',
      func: 'applycustomization',
      inputType: 'dropdown',
      className: 'StackPosition',
      id: 'StackPosition',
      options: [
        { value: 'BrandsinX', label: 'Brands in X axis and Metrics in Y axis', selected: true },
        { value: 'MetricinY', label: 'Metrics in X axis and Brands Y axis', selected: false },
      ],
    },
  }

  commoncustomizationlist() {
    let commoncustomization = [
      {
        customization: 'Decimal Round Off : ',
        func: 'applycustomization',
        inputType: 'dropdown',
        className: '',
        id: 'Decimal Round Off',
        options: [{ value: 0, label: 'None' },
        { value: 1, label: 'One Decimal Point' },
        { value: 2, label: 'Two Decimal Point' }],
      },
      {
        customization: 'Info Button : ',
        func: 'applycustomization',
        inputType: 'dropdown',
        className: '',
        id: 'Info Button',
        options: [{ value: 'none', label: 'None' }, { value: 'fom', label: 'FOM Tooltip' }, { value: 'custom', label: 'Custom' }],
      },
      {
        customization: 'Legend : ',
        func: 'applycustomization',
        inputType: 'images',
        className: 'Legend',
        id: 'Legend',
        options: [
          {
            value: 'enable',
            label: 'Enable',
            selected: false,
            imgClassName: 'legendEnable',
            selectedImgClassName: 'legendEnableSelected',
          },
          {
            value: 'disable',
            label: 'Disable',
            selected: true,
            imgClassName: 'legendDisable',
            selectedImgClassName: 'legendDisableSelected',
          },
        ],
      },
      {
        customization: 'Position : ',
        func: 'applycustomization',
        inputType: 'images',
        className: 'LegendGrouping',
        id: 'Legend Position',
        options: [
          {
            value: 'left',
            label: 'Left',
            selected: false,
            imgClassName: 'legendLeft',
            selectedImgClassName: 'legendLeftSelected',
          },
          {
            value: 'bottom',
            label: 'Bottom',
            selected: true,
            imgClassName: 'legendBottom',
            selectedImgClassName: 'legendBottomSelected',
          },
          {
            value: 'right',
            label: 'Right',
            selected: false,
            imgClassName: 'legendRight',
            selectedImgClassName: 'legendRightSelected',
          }, // Add this option for 'Right'
        ],
      },
      {
        customization: 'Data Label : ',
        func: 'applycustomization',
        inputType: 'toggle',
        className: 'DataLabel',
        id: 'Data Label',
        options: [
          { value: 'enable', label: 'On', selected: true },
          { value: 'disable', label: 'Off', selected: false },
        ],
      },
      {
        customization: 'Color : ',
        func: 'applycustomization',
        inputType: 'color',
        className: 'DataLabelGrouping',
        id: 'Data Label Color',
        value: '#000000',
      },

      {
        customization: 'Property : ',
        func: 'applycustomization',
        inputType: 'dropdown',
        className: 'DataLabelGrouping',
        id: 'Data Label Property',
        options: [
          { value: 'datalabel', label: 'Default ' },
          { value: 'change', label: 'Change Versus ' },
          {
            value: 'significance + changeVs',
            label: 'Change Versus + Significance',
          },

          { value: 'significance', label: 'Significance ' },
          { value: 'significance2', label: 'Significance Level2' },

          { value: 'ls', label: 'Low Sample ' },
        ],
      },

      {
        customization: 'Size : ',
        func: 'applycustomization',
        inputType: 'dropdown',
        className: 'DataLabelGrouping',
        id: 'Data Label Size',
        options: [
          { value: '1em', label: '1 Em' },
          { value: '0.9em', label: '0.9 Em' },
          { value: '0.8em', label: '0.8 Em' },
          { value: '0.7em', label: '0.7 Em' },
        ],
      },
      {
        customization: 'Position : ',
        func: 'applycustomization',
        inputType: 'dropdown',
        className: 'DataLabelGrouping',
        id: 'Data Label Position',
        options: [
          { value: 'middle', label: 'Center' },
          { value: 'top', label: 'Top' },
          { value: 'bottom', label: 'Bottom' },
        ],
      },
    ];
    return commoncustomization;
  }

  applycustomization(event: any, item: any, properties: any) {
    switch (item) {
      case 'Stack position': {
        properties.stackPosition = event.target.value;
        break;
      }
      case 'Data Label Property': {
        properties.datalabelStyle = event.target.value;
        break;
      }
      case 'Data Label Size': {
        properties.dataLabelSize = event.target.value;
        break;
      }
      case 'Start Value': {
        properties.startvalue = Number(event.value);
        break;
      }
      case 'End Value': {
        properties.endvalue = Number(event.value);
        break;
      }
      case 'Target Value': {
        if(event.target.value === ''){
          properties.Target=false;
        }
        else{
          properties.Target=true;
        }
        properties.Targetvalue = Number(event.value);
        break;
      }
      case 'Data Label Position': {
        properties.dataLabelPosition = event.target.value;
        break;
      }
      case 'Gridlines dash ': {
        properties.gridlinestyle = event.target.value;
        break;
      }
      case 'Line Style ': {
        properties.Linestyle = event.target.value;
        break;
      }
      case 'Marker Style': {
        properties.markerStyle = event.target.value;
        break;
      }
      case 'Column Header Font Size': {
        properties.ColumnHeaderFontSize = event.target.value;
        break;
      }
      case 'Column Header Alignment': {
        properties.ColumnHeaderAlignment = event.target.value;
        break;
      }
      case 'Row Header Font Size': {
        properties.RowHeaderFontSize = event.target.value;
        break;
      }
      case 'Row Header Alignment': {
        properties.RowHeaderAlignment = event.target.value;
        break;
      }
      case 'Data Label Alignment': {
        properties.dataLabelAlignment = event.target.value;
        break;
      }
      case 'Data Label Alignment': {
        properties.dataLabelAlignment = event.target.value;
        break;
      }
   
      case 'Data Label Colour': {
        properties.dataLabelColor = event.target.value;
        break;
      }
      case 'Quadrant Position': {
        properties.quadrantPosition = event.target.value;
        break;
      }
      case 'Fixed X-Axis Value': {
        properties.fixedXAxisValue = parseFloat(event.target.value) || 0;
        break;
      }
      case 'Fixed Y-Axis Value': {
        properties.fixedYAxisValue = parseFloat(event.target.value) || 0;
        break;
      }
      case 'Quadrant Dash Style ': {
        properties.dashStyle = event.target.value;
        properties.showQuadrantcolor = properties.dashStyle === 'none' ? '#808080' : 'black';
        break
      }
      case 'Quadrant Color Code': {
        properties.showQuadrantcolor = event.target.value;
        if (properties.dashStyle === 'none') {
          properties.showQuadrantcolor = '#808080';
        }
        break
      }
      case 'Gridlines colour ': {
        properties.gridlinecolor = event.target.value;
        break
      }
      case 'Column Header Font  Colour': {
        properties.ColumnHeaderFontColor = event.target.value;
        break
      }
      case 'Column Header Cell  Colour': {
        properties.ColumnHeaderCellColor = event.target.value;
        break
      }
      case 'Row Header Font Colour': {
        properties.RowHeaderFontColor = event.target.value;
        break
      }
      case 'Row Header Cell  Colour': {
        properties.RowHeaderCellColor = event.target.value;
        break
      }

      case 'Data Label': {
        properties.showDataLabel = event.target.value;
        break;
      }
      case 'Banded Column': {
        properties.BannedColumn = event.target.value;
        properties.BandedColumn1=true;
        properties.BandedRow1=false;
        break;
      }
      case 'Banded Row': {
        properties.BannedRow = event.target.value;
        properties.BandedColumn1=false;
        properties.BandedRow1=true;
        break;
      }
      case 'Border Colour': {
        properties.borderColor = event.target.value;
        break;
      }
      case 'First Column as header': {
        properties.FirstColumn = event.target.checked;
        break;
      }
      case 'First Row as header': {
        properties.FirstRow = event.target.checked;
        break;
      }
      case 'Fixed Circle Radius': {
      
         if(event.target.value === ''){
          properties.fixedCircleRadius=false;
        }
        else{
          properties.fixedCircleRadius=true;
        }
        properties.fixedCircleRadiusValue = Number(event.value);
        break;
      }
       case 'Trendline in Exports ': {
         properties.TrendlineinExports = event.target.checked;
         break;
       }
      case 'Border Thickness': {
        if(event.target.value == "All"){
          properties.borderStyle = "2";
        }
        else if(event.target.value == "Outside"){
          properties.borderStyle = "1";
        }
        else{
          properties.borderStyle = "0";
        }
        break;
      }
      case 'Legend Position':
      case "Legend position":{
        var clickedDiv = event.currentTarget as HTMLDivElement;
        var value = clickedDiv.getAttribute('value');
        properties['legendPosition'] = value;
        break;
      }
      case 'Legend': {
        var clickedDiv = event.currentTarget as HTMLDivElement;
        var value = clickedDiv.getAttribute('value');
        properties['showLegend'] = value == 'disable' ? false : true;
        break;
      }
      case '100% Stack chart': {
        properties.stacking = event.target.value;
        break;
      }
      case 'X Axis Label Orientation': {
        var clickedDiv = event.currentTarget as HTMLDivElement;
        var value = clickedDiv.getAttribute('value');
        properties['axisLabelOrientation'] = value;
        break;
      }

      case 'Y Axis Label Orientation': {
        var clickedDiv = event.currentTarget as HTMLDivElement;
        var value = clickedDiv.getAttribute('value');
        properties['yaxisLabelOrientation'] = value;
        break;
      }

      case "Decimal Round Off":
      case "Decimal Round off": {
        properties.decimalRoundOff = Number(event.target.value);
        break;
      }
      case 'Transpose':
        properties.StackFormat = event.target.textContent;
        break;
      case "Number of Levels":
        properties.numberOfFunnelLevels = Number(event);
        break;

      case "BIPS-Negativetext":
        properties.bipsNegativeRange= Number(event.target.value);
        break;
      
      case "BIPS-Positivetext":
          properties.bipsPositiveRange= Number(event.target.value);
          break;
      case "BIPS-Negativecolor":
        properties.bipsNegativeRangeColor = event.target.value;
        break;
      
      case "BIPS-Positivecolor":
          properties.bipsPositiveRangeColor = event.target.value;
          break;
      case 'Calculation Logic': {
        properties.CalculationLogic = event.target.value;
        break;
      }
      case "Calculation-Nonecolor":
        properties.calculationNoneColor = event.target.value;
        break;
      case "Enable data bars(within cells)":
        properties.enableDataBars=event.target.checked;
        break;
    }
  }

  // applycustomization(event: any, item: any, properties: any) {
  //   switch (item) {
  //     case 'StackPosition': {
  //       properties.stackPosition = event.target.value;
  //       break;
  //     }
  //     case 'Data Label Property': {
  //       properties.datalabelStyle = event.target.value;
  //       break;
  //     }
  //     case 'Data Label Size': {
  //       properties.dataLabelSize = event.target.value;
  //       break;
  //     }
  //     case 'Data Label Position': {
  //       properties.dataLabelPosition = event.target.value;
  //       break;
  //     }
  //     case 'Data Label Color': {
  //       properties.dataLabelColor = event.target.value;
  //       break;
  //     }
  //     case 'Quadrant Dash Style :': {
  //       break
  //     }
  //     case 'Data Label': {
  //       properties.showDataLabel = event.target.value;
  //       break;
  //     }
  //     case 'Legend Position': {
  //       var clickedDiv = event.currentTarget as HTMLDivElement;
  //       var value = clickedDiv.getAttribute('value');
  //       properties['legendPosition'] = value;
  //       break;
  //     }
  //     case 'Legend': {
  //       var clickedDiv = event.currentTarget as HTMLDivElement;
  //       var value = clickedDiv.getAttribute('value');
  //       properties['showLegend'] = value == 'disable' ? false : true;
  //       break;
  //     }
  //     case '100PercentStackedChart': {
  //       properties.stacking = !event.target.value;
  //       break;
  //     }
  //     case 'X Axis Label Orientation': {
  //       var clickedDiv = event.currentTarget as HTMLDivElement;
  //       var value = clickedDiv.getAttribute('value');
  //       properties['axisLabelOrientation'] = value;
  //       break;
  //     }

  //     case 'Y Axis Label Orientation': {
  //       var clickedDiv = event.currentTarget as HTMLDivElement;
  //       var value = clickedDiv.getAttribute('value');
  //       properties['yaxisLabelOrientation'] = value;
  //       break;
  //     }

  //     case "Decimal Round Off": {
  //       properties.decimalRoundOff = Number(event.target.value);
  //       break;
  //     }

  //   }
  // }

  getCustomization(): Observable<any> {
    return this._configService.getCustomProperties().pipe(
      map((response: any) => response.Data)
    );
  }
 
  
  // colortemplate() {
  //       this.configureservice.savedModule(this._configService.SnapshotList[0].ClientName).subscribe((result: results) => {
  //       // if valid responses
  colortemplate(clientName?: string) {
    const nameToUse = clientName || this._configService.SnapshotList[0].ClientName;
          this.configureservice.savedModule(nameToUse).subscribe((result: results) => {
    //       // if valid responses
        if (result.HasValidData) {
          if (result.Data != "") {
  
            let data = JSON.parse(result.Data);
  
  
            if (data.length > 0) {
              if(data[0].color_palette!=null){
                this.color1=data[0].color_palette;
                this.brandcolors = data[0].brand_colors;
              }else{
                this.color1=[
                    "#9bc5e5",
                    "#d5bce4",
                    "#ff97a8",
                    "#a7e2d7",
                    "#ffcc66",
                    "#ff9966",
                    "#6799cc",
                    "#cdcc66",
                    "#f4e4b3",
                    "#47b7ae",
                    "#f9c099",
                    "#7fb6c6",
                    "#2c70a3",
                    "#d6a365",
                    "#802ab7",
                    "#00b6ff",
                    "#417f54",
                    "#bf5c9e",
                    "#62849b",
                    "#e5ce85",
                    "#ae3875",
                    "#6750a4",
                    "#798987",
                    "#b2f9ee",
                    "#dd8340",
                    "#2d97a5",
                    "#bd78ef",
                    "#af7f4f",
                    "#7f5aa3",
                    "#5c752d"
                  ];
              }
             
            }
           
          }
          
  
          //this.moduleName.forEach((item: any) => {
          //    item.is_active = false;
          //});
  
          // this.getLogo(selectedClientName);
  
        }
        //this._loaderService.hideLoader();
      });
  
    }

}
